import TextField from "@/components/layouts/History/TextField";
import { useCompanyIndustries } from "@/pages/companies/hooks";
import { LookupNameFromIdx } from "@/utils/datamaps";
import { useTranslation } from "react-i18next";

interface Props {
  value: string;
}

const IndustryName: React.FC<Props> = ({ value }) => {
  const { t } = useTranslation();
  const companyIndustries = useCompanyIndustries().data?.industries ?? [];
  const industryName = LookupNameFromIdx(
    t,
    "companies.industriesValues",
    companyIndustries,
    Number(value)
  );
  return <TextField>{industryName}</TextField>;
};

export default IndustryName;
